import { subWeeks } from "date-fns";

export const STATISTICS_TYPE_CHOICES = [
  { id: "all", name: "All" },
  { id: "paid", name: "Paid" },
  { id: "organic", name: "Organic" },
];

export const DEFAULT_DATE_START = subWeeks(new Date(), 1);
export const DEFAULT_DATE_END = new Date();
export const ALL_OPTION = { id: "all", name: "All" };

export const STATISTICS_TIMEZONES_CHOICES = [
  { id: "+3:00", name: "Default" },
  { id: "+0:00", name: "UTC" },
];

export const STATISTICS_REBILLS_BY_CHOICES = [
  { id: "date_created", name: "Date Created" },
  { id: "date_updated", name: "Date Updated" },
];

export const GROUPS = {
  ZONE_ID: "zone_id",
  COUNTRY: "country",
};

export const TOTAL_GROUP = "total";
